import me from "models/me";
import { getStore } from "store";
import { fetchRequestedConnections } from "../actions/connection-requests";

export default function (_nextState, _replace, callback) {
    const store = getStore();

    if (me.isSignedIn() && me.account_type === "buyer") {
        store.dispatch(fetchRequestedConnections()).then(() => {
            callback();
        });
    } else {
        callback();
    }
}
